"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFavoriteOfferButton = useFavoriteOfferButton;
const react_1 = require("react");
const SymfonyRouter_1 = __importDefault(require("@react/common/SymfonyRouter/SymfonyRouter"));
const ErrorMessageEnum_1 = require("@react/web/Common/FavoriteOfferButton/ErrorMessageEnum");
const FavoriteOfferButtonState_1 = __importDefault(require("@react/web/Common/FavoriteOfferButton/FavoriteOfferButtonState"));
const gtmEvent_1 = __importDefault(require("@react/web/Common/FavoriteOfferButton/gtmEvent"));
const PriceOfferUrlData_1 = __importDefault(require("@react/web/Common/FavoriteOfferButton/PriceOfferUrlData"));
function useFavoriteOfferButton(currentDisplayedPriceOffer) {
    const [componentState, setComponentState] = (0, react_1.useState)(FavoriteOfferButtonState_1.default.LOADING);
    const [isPriceOfferInFavorites, setIsPriceOfferInFavorites] = (0, react_1.useState)(false);
    const [errorMessage, setErrorMessage] = (0, react_1.useState)(null);
    const updateFavoritesPriceOffersCount = (currentFavoriteOfferCount) => {
        const itemsCounter = document.getElementById('favorite-items-count');
        const headerFavoritePriceOffersLink = document.getElementById('header-favorite-price-offers-link');
        if (itemsCounter && headerFavoritePriceOffersLink) {
            itemsCounter.innerHTML = currentFavoriteOfferCount.toString();
            const updateTooltipEvent = new CustomEvent('updateTooltipEvent', {
                detail: {
                    count: currentFavoriteOfferCount,
                },
            });
            headerFavoritePriceOffersLink.dispatchEvent(updateTooltipEvent);
        }
    };
    const setupErrorMessage = (messageType) => {
        setErrorMessage((0, ErrorMessageEnum_1.ErrorMessageEnum)(messageType));
        setComponentState(FavoriteOfferButtonState_1.default.READY);
    };
    const handleAddToFavorites = () => {
        if (currentDisplayedPriceOffer) {
            setComponentState(FavoriteOfferButtonState_1.default.SENDING);
            const url = SymfonyRouter_1.default.getRoute('api.subscription_offer.save_favorite', (0, PriceOfferUrlData_1.default)(currentDisplayedPriceOffer));
            fetch(url, {
                method: 'POST',
            })
                .then((response) => {
                if (response.status === 200) {
                    response.json().then((json) => {
                        const currentFavoritesOfferCount = json.current_favorite_price_offer_count;
                        updateFavoritesPriceOffersCount(currentFavoritesOfferCount);
                        (0, gtmEvent_1.default)(currentDisplayedPriceOffer.priceOfferId);
                        setIsPriceOfferInFavorites(true);
                        setComponentState(FavoriteOfferButtonState_1.default.READY);
                        setupErrorMessage(null);
                    });
                }
                else {
                    setupErrorMessage(ErrorMessageEnum_1.ErrorMessageTypeEnum.ADD);
                }
            })
                .catch((e) => {
                console.warn(`Catch handleAddToFavorites error | ${e}`);
                setupErrorMessage(ErrorMessageEnum_1.ErrorMessageTypeEnum.ADD);
            });
        }
    };
    const handleRemoveFromFavorites = () => {
        if (currentDisplayedPriceOffer) {
            setComponentState(FavoriteOfferButtonState_1.default.SENDING);
            const url = SymfonyRouter_1.default.getRoute('api.subscription_offer.remove_favorite', (0, PriceOfferUrlData_1.default)(currentDisplayedPriceOffer));
            fetch(url, {
                method: 'POST',
            })
                .then((response) => {
                if (response.status === 200) {
                    response.json().then((json) => {
                        const currentFavoritesOfferCount = json.current_favorite_price_offer_count;
                        updateFavoritesPriceOffersCount(currentFavoritesOfferCount);
                        setIsPriceOfferInFavorites(false);
                        setComponentState(FavoriteOfferButtonState_1.default.READY);
                        setupErrorMessage(null);
                    });
                }
                else {
                    setupErrorMessage(ErrorMessageEnum_1.ErrorMessageTypeEnum.REMOVE);
                }
            })
                .catch((e) => {
                console.warn(`Catch handleRemoveFromFavorites error | ${e}`);
                setupErrorMessage(ErrorMessageEnum_1.ErrorMessageTypeEnum.REMOVE);
            });
        }
    };
    const handleRemoveErrorMessage = () => {
        setupErrorMessage(null);
    };
    const checkPriceOfferIsInFavorites = () => {
        if (currentDisplayedPriceOffer) {
            setComponentState(FavoriteOfferButtonState_1.default.LOADING);
            const url = SymfonyRouter_1.default.getRoute('api.subscription_offer.is_favorite', {
                subscriptionCarOfferId: currentDisplayedPriceOffer.subscriptionOfferId,
            });
            fetch(url, {
                method: 'GET',
            })
                .then((response) => {
                if (response.status === 200) {
                    response.json().then((json) => {
                        var _a;
                        const id = (_a = json.id) !== null && _a !== void 0 ? _a : null;
                        setIsPriceOfferInFavorites(id === currentDisplayedPriceOffer.priceOfferId);
                        setComponentState(FavoriteOfferButtonState_1.default.READY);
                        setupErrorMessage(null);
                    });
                }
                else {
                    setupErrorMessage(ErrorMessageEnum_1.ErrorMessageTypeEnum.LOAD);
                }
            })
                .catch((e) => {
                console.warn(`Catch checkPriceOfferIsInFavorites error | ${e}`);
                setupErrorMessage(ErrorMessageEnum_1.ErrorMessageTypeEnum.LOAD);
            });
        }
    };
    (0, react_1.useEffect)(() => {
        checkPriceOfferIsInFavorites();
    }, []);
    return {
        handleAddToFavorites,
        handleRemoveFromFavorites,
        handleRemoveErrorMessage,
        componentState,
        isPriceOfferInFavorites,
        errorMessage,
    };
}
